// src/services/conversationService.js
import { api } from "../lib/apiClient";

/** POST /conversations  →  crée la conv + 1er message bot */
export async function createConversation(payload, authToken) {
  const payloadMapped = {
    session_slug: payload.sessionSlug,
    ciaov2_job_id: payload.jobId,
    ciaov2_user_id: payload.userId,
    bot_name: payload.botName,
    gender: payload.gender,
    bot_type: payload.bot_type
  }
  const { data } = await api.post("/ciaov2_conversations_v2", payloadMapped, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
}

/** PUT /conversations/:id  →  append un message */
export async function addMessage(payload, authToken) {
  const jobId = payload.jobId == 'lux' ? 0 : payload.jobId
  const { data } = await api.post(`/ciaov2_conversations_v2_message/${payload.conversation_id}`, {message: payload.message}, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data
}

/** PUT /conversations/:id  →  append un message */
export async function rateConversationApi(payload, authToken) {
  const jobId = payload.jobId == 'lux' ? 0 : payload.jobId
  await api.put(`/ciaov2_conversations/${jobId}/${payload.gender}/rate`, {rating: payload.rating}, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

/** GET /conversations      →  l’historique d’un user */
export async function fetchConversations(authToken) {
  const { data } = await api.get("/ciaov2_conversations_v2", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;             // [{ id, sessionSlug, title, messages, … }, …]
}
